import { CSSProperties, ImgHTMLAttributes, SourceHTMLAttributes } from "react";

export type AspectRatios = "1/1" | "2/1" | "16/9" | "3/2" | "4/3" | "none";

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt: string;
    aspectRatio?: AspectRatios;
}

const imageCSS = (ratio?: AspectRatios) => {
    const aspectRatioCSS =
        ratio && ratio !== "none"
            ? { aspectRatio: ratio, objectFit: "cover", width: "100%" }
            : {};
    return { maxWidth: "100%", ...aspectRatioCSS };
};

/**
 * @deprecated - Please use Picture instead
 */
export const Image = ({ src, alt, aspectRatio, ...rest }: ImageProps) => {
    return (
        <img
            src={src}
            alt={alt}
            style={imageCSS(aspectRatio) as CSSProperties}
            {...rest}
        />
    );
};

export type PictureProps = {
    sources?: Array<SourceHTMLAttributes<HTMLSourceElement>>;
    image: ImageProps;
};

export const Picture = ({
    sources,
    image: { src, alt, aspectRatio, ...image }
}: PictureProps) => {
    return sources ? (
        <picture>
            {sources.map((source, index) => (
                <source key={index} {...source} />
            ))}
            <img
                {...image}
                src={src}
                alt={alt}
                style={imageCSS(aspectRatio) as CSSProperties}
            />
        </picture>
    ) : (
        <img
            {...image}
            src={src}
            alt={alt}
            style={imageCSS(aspectRatio) as CSSProperties}
        />
    );
};
